export enum AdvancedBookingAlertTypeEnum {
  AWB = "awbRequired",
  AIRLINE_CONTACT = "airlineContact",
  FLIGHTS = "flightNo",
  WARNING = "warning",
  CANCEL = "cancel",
  DUPLICATE_AWB = "usedAWB",
}
